import React from 'react';

export default {
  bbkMiniLogo: (
    <svg width="20px" height="19px" viewBox="0 0 20 19" version="1.1">
      <g
        id="Reasons-map"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="v3-01-TAB:-Reasons---default"
          transform="translate(-1130.000000, -828.000000)"
        >
          <g id="Group-13" transform="translate(1101.000000, 694.000000)">
            <g
              id="Dynamic-group-Copy"
              transform="translate(29.000000, 131.000000)"
            >
              <g id="logomark" transform="translate(0.000000, 3.000000)">
                <polygon
                  id="Fill-110-Copy-11"
                  fill="#FF75B3"
                  points="16.7930029 18.3603635 11.1953353 18.3603635 13.9941691 13.7702624"
                />
                <polygon
                  id="Fill-110-Copy-10"
                  fill="#FF7575"
                  points="19.5918367 13.7702624 13.9941691 13.7702624 16.7930029 18.3603362"
                />
                <polygon
                  id="Fill-110-Copy-14"
                  fill="#C76ECC"
                  points="11.1953353 18.3603635 5.59766764 18.3603635 8.39650146 13.7702624"
                />{' '}
                <polygon
                  id="Fill-110-Copy-13"
                  fill="#EB73D5"
                  points="13.9941691 13.7702624 8.39650146 13.7702624 11.1953353 18.3603362"
                />{' '}
                <polygon
                  id="Fill-110-Copy-16"
                  fill="#745185"
                  points="5.59766764 18.3603635 0 18.3603635 2.79883382 13.7702624"
                />{' '}
                <polygon
                  id="Fill-110-Copy-15"
                  fill="#9260AB"
                  points="8.39650146 13.7702624 2.79883382 13.7702624 5.59766764 18.3603362"
                />{' '}
                <polygon
                  id="Fill-110-Copy-17"
                  fill="#745185"
                  points="8.39650146 13.7702761 2.79883382 13.7702761 5.59766764 9.18017493"
                />{' '}
                <polygon
                  id="Fill-110-Copy-12"
                  fill="#FF9C75"
                  points="19.5918367 13.7702761 13.9941691 13.7702761 16.7930029 9.18017493"
                />{' '}
                <polygon
                  id="Fill-110-Copy-9"
                  fill="#FFB575"
                  points="16.7930029 9.18017493 11.1953353 9.18017493 13.9941691 13.7702487"
                />{' '}
                <polygon
                  id="Fill-110"
                  fill="#5E3799"
                  points="5.59766764 9.18018859 0 9.18018859 2.79883382 4.59008746"
                />{' '}
                <polygon
                  id="Fill-110-Copy"
                  fill="#425AB8"
                  points="8.39650146 4.59008746 2.79883382 4.59008746 5.59766764 9.18016126"
                />{' '}
                <polygon
                  id="Fill-110-Copy-8"
                  fill="#FFD175"
                  points="16.7930029 9.18018859 11.1953353 9.18018859 13.9941691 4.59008746"
                />{' '}
                <polygon
                  id="Fill-110-Copy-7"
                  fill="#FFF175"
                  points="19.5918367 4.59008746 13.9941691 4.59008746 16.7930029 9.18016126"
                />{' '}
                <polygon
                  id="Fill-110-Copy-2"
                  fill="#0E96B8"
                  points="8.39650146 4.59010113 2.79883382 4.59010113 5.59766764 0"
                />{' '}
                <polygon
                  id="Fill-110-Copy-6"
                  fill="#A5ED4E"
                  points="19.5918367 4.59010113 13.9941691 4.59010113 16.7930029 0"
                />{' '}
                <polygon
                  id="Fill-110-Copy-3"
                  fill="#0CB07C"
                  points="11.1953353 0 5.59766764 0 8.39650146 4.5900738"
                />{' '}
                <polygon
                  id="Fill-110-Copy-5"
                  fill="#27BA51"
                  points="13.9941691 4.59010113 8.39650146 4.59010113 11.1953353 0"
                />{' '}
                <polygon
                  id="Fill-110-Copy-4"
                  fill="#6FD640"
                  points="16.7930029 0 11.1953353 0 13.9941691 4.5900738"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  brightbackMiniLogo: (
    <svg width="20px" height="19px" viewBox="0 0 20 19" version="1.1">
      <g
        id="Reasons-map"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="v3-01-TAB:-Reasons---default"
          transform="translate(-1130.000000, -828.000000)"
        >
          <g id="Group-13" transform="translate(1101.000000, 694.000000)">
            <g
              id="Dynamic-group-Copy"
              transform="translate(29.000000, 131.000000)"
            >
              <g id="logomark" transform="translate(0.000000, 3.000000)">
                <polygon
                  id="Fill-110-Copy-11"
                  fill="#FF75B3"
                  points="16.7930029 18.3603635 11.1953353 18.3603635 13.9941691 13.7702624"
                />
                <polygon
                  id="Fill-110-Copy-10"
                  fill="#FF7575"
                  points="19.5918367 13.7702624 13.9941691 13.7702624 16.7930029 18.3603362"
                />
                <polygon
                  id="Fill-110-Copy-14"
                  fill="#C76ECC"
                  points="11.1953353 18.3603635 5.59766764 18.3603635 8.39650146 13.7702624"
                />{' '}
                <polygon
                  id="Fill-110-Copy-13"
                  fill="#EB73D5"
                  points="13.9941691 13.7702624 8.39650146 13.7702624 11.1953353 18.3603362"
                />{' '}
                <polygon
                  id="Fill-110-Copy-16"
                  fill="#745185"
                  points="5.59766764 18.3603635 0 18.3603635 2.79883382 13.7702624"
                />{' '}
                <polygon
                  id="Fill-110-Copy-15"
                  fill="#9260AB"
                  points="8.39650146 13.7702624 2.79883382 13.7702624 5.59766764 18.3603362"
                />{' '}
                <polygon
                  id="Fill-110-Copy-17"
                  fill="#745185"
                  points="8.39650146 13.7702761 2.79883382 13.7702761 5.59766764 9.18017493"
                />{' '}
                <polygon
                  id="Fill-110-Copy-12"
                  fill="#FF9C75"
                  points="19.5918367 13.7702761 13.9941691 13.7702761 16.7930029 9.18017493"
                />{' '}
                <polygon
                  id="Fill-110-Copy-9"
                  fill="#FFB575"
                  points="16.7930029 9.18017493 11.1953353 9.18017493 13.9941691 13.7702487"
                />{' '}
                <polygon
                  id="Fill-110"
                  fill="#5E3799"
                  points="5.59766764 9.18018859 0 9.18018859 2.79883382 4.59008746"
                />{' '}
                <polygon
                  id="Fill-110-Copy"
                  fill="#425AB8"
                  points="8.39650146 4.59008746 2.79883382 4.59008746 5.59766764 9.18016126"
                />{' '}
                <polygon
                  id="Fill-110-Copy-8"
                  fill="#FFD175"
                  points="16.7930029 9.18018859 11.1953353 9.18018859 13.9941691 4.59008746"
                />{' '}
                <polygon
                  id="Fill-110-Copy-7"
                  fill="#FFF175"
                  points="19.5918367 4.59008746 13.9941691 4.59008746 16.7930029 9.18016126"
                />{' '}
                <polygon
                  id="Fill-110-Copy-2"
                  fill="#0E96B8"
                  points="8.39650146 4.59010113 2.79883382 4.59010113 5.59766764 0"
                />{' '}
                <polygon
                  id="Fill-110-Copy-6"
                  fill="#A5ED4E"
                  points="19.5918367 4.59010113 13.9941691 4.59010113 16.7930029 0"
                />{' '}
                <polygon
                  id="Fill-110-Copy-3"
                  fill="#0CB07C"
                  points="11.1953353 0 5.59766764 0 8.39650146 4.5900738"
                />{' '}
                <polygon
                  id="Fill-110-Copy-5"
                  fill="#27BA51"
                  points="13.9941691 4.59010113 8.39650146 4.59010113 11.1953353 0"
                />{' '}
                <polygon
                  id="Fill-110-Copy-4"
                  fill="#6FD640"
                  points="16.7930029 0 11.1953353 0 13.9941691 4.5900738"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  bbkMiniLogoTrans: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="21"
      viewBox="0 0 22 21"
    >
      <g fill="#FFF" fillRule="evenodd">
        <polygon
          points="18.472 20.196 12.315 20.196 15.394 15.147"
          opacity=".6"
        />
        <polygon
          points="21.551 15.147 15.394 15.147 18.472 20.196"
          opacity=".8"
        />
        <polygon
          points="12.315 20.196 6.157 20.196 9.236 15.147"
          opacity=".4"
        />
        <polygon
          points="15.394 15.147 9.236 15.147 12.315 20.196"
          opacity=".5"
        />
        <polygon points="6.157 20.196 0 20.196 3.079 15.147" opacity=".4" />
        <polygon points="9.236 15.147 3.079 15.147 6.157 20.196" opacity=".3" />
        <polygon points="9.236 15.147 3.079 15.147 6.157 10.098" opacity=".2" />
        <polygon
          points="21.551 15.147 15.394 15.147 18.472 10.098"
          opacity=".7"
        />
        <polygon
          points="18.472 10.098 12.315 10.098 15.394 15.147"
          opacity=".8"
        />
        <polygon points="6.157 10.098 0 10.098 3.079 5.049" opacity=".2" />
        <polygon points="9.236 5.049 3.079 5.049 6.157 10.098" opacity=".4" />
        <polygon
          points="18.472 10.098 12.315 10.098 15.394 5.049"
          opacity=".7"
        />
        <polygon
          points="21.551 5.049 15.394 5.049 18.472 10.098"
          opacity=".8"
        />
        <polygon points="9.236 5.049 3.079 5.049 6.157 0" opacity=".3" />
        <polygon points="21.551 5.049 15.394 5.049 18.472 0" opacity=".8" />
        <polygon points="12.315 0 6.157 0 9.236 5.049" opacity=".4" />
        <polygon points="15.394 5.049 9.236 5.049 12.315 0" opacity=".3" />
        <polygon points="18.472 0 12.315 0 15.394 5.049" opacity=".6" />
      </g>
    </svg>
  ),
  copperMiniLogo: (
    <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1">
      <g
        id="Reasons-map"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="v3-01-TAB:-Reasons---default"
          transform="translate(-1131.000000, -885.000000)"
        >
          <g id="Group-13" transform="translate(1101.000000, 694.000000)">
            <g id="Group-12" transform="translate(30.000000, 190.000000)">
              <image
                id="Bitmap"
                x="0"
                y="1"
                width="20"
                height="20"
                href="data:image/png;base64,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"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
};
